import { render, staticRenderFns } from "./BookWizard.vue?vue&type=template&id=fada7d1c&"
import script from "./BookWizard.vue?vue&type=script&lang=js&"
export * from "./BookWizard.vue?vue&type=script&lang=js&"
import style0 from "./BookWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports